<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <div>
      <v-layout>
        <v-row justify="center">
          <v-col style="max-width:1200px">
            <material-card
              :title="$t('components.search_beneficiaries_form.title')"
              :color="$vuetify.theme.themes.light.secondary"
              icon="person_search"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="6" v-if="selectedPlan.PlanType === 'Pension'">
                    <no-autocomplete-textfield
                      clearable
                      v-model="searchForm.pensionMembershipId"
                      :label="$t('headers.members_management.Membership Id')"
                    />
                  </v-col>

                  <v-col cols="6">
                    <v-select
                      v-model="searchForm.beneficiaryType"
                      :items="beneficiaryTypes"
                      :label="
                        selectedPlan.PlanType === 'Pension'
                          ? $t(
                              'components.search_beneficiaries_form.beneficiary_type'
                            )
                          : $t(
                              'components.search_beneficiaries_form.relationship_type'
                            )
                      "
                      :rules="[$rules.required]"
                      class="required"
                    ></v-select>
                  </v-col>

                  <v-col cols="6">
                    <no-autocomplete-textfield
                      clearable
                      v-model="searchForm.lastName"
                      :label="$t('headers.members_management.Last Name')"
                    />
                  </v-col>
                  <v-col cols="6">
                    <no-autocomplete-textfield
                      clearable
                      v-model="searchForm.firstName"
                      :label="$t('headers.members_management.First Name')"
                    />
                  </v-col>

                  <v-col cols="6" v-if="selectedPlan.PlanType === 'Pension'">
                    <no-autocomplete-textfield
                      clearable
                      v-model="searchForm.beneficiarySpouseId"
                      :label="
                        $t(
                          'components.search_beneficiaries_form.beneficiary_spouse_id'
                        )
                      "
                    />
                  </v-col>

                  <v-col cols="6">
                    <no-autocomplete-textfield
                      clearable
                      v-model="searchForm.sin"
                      :label="$t('headers.members_management.SIN')"
                    />
                  </v-col>
                  <v-col cols="6">
                    <pbas-date-picker
                      clearable
                      :label="$t('headers.members_management.Date Of Birth')"
                      :value="searchForm.dateOfBirth"
                      @update-date="searchForm.dateOfBirth = $event"
                    ></pbas-date-picker>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      @click="submitSearchForm"
                      :disabled="
                        searchForm.beneficiaryType === null ||
                          searchForm.beneficiaryType === undefined
                      "
                    >
                      {{ $t("pbascomponents.pbasdatatable.search") }}
                    </v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      text
                      @click="
                        searchForm.firstName = null;
                        searchForm.lastName = null;
                        searchForm.pensionMembershipId = null;
                        searchForm.sin = null;
                        searchForm.dateOfBirth = null;
                        searchForm.beneficiaryType = null;
                        searchForm.dateOfBirth = null;
                        searchForm.beneficiarySpouseId = null;
                        provider = undefined;
                        submitSearchForm();
                      "
                    >
                      {{ $t("globals.reset") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </material-card>
          </v-col>
        </v-row>
      </v-layout>
      <v-layout v-if="showTable">
        <v-row justify="center">
          <v-col style="max-width:1200px">
            <v-card>
              <v-card-text>
                <div>
                  <v-icon>list</v-icon>
                  {{ $t("components.membersmanagementtable.results") }}
                </div>
                <pbas-data-table
                  ref="table"
                  :dataProvider="provider"
                  :rowActions="rowActions"
                  :fileNamePrefix="
                    url.indexOf('dependants') ? 'dependants' : 'beneficiaries'
                  "
                  identifier="search-beneficiaries-table"
                  :noSearch="true"
                  :noActions="true"
                  :exportDataSwitch="true"
                  @error="
                    error = $event;
                    result = [];
                  "
                  @itemsChanged="setData"
                  :exporters="$exporters"
                  :showSelect="false"
                ></pbas-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
    </div>

    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import getDependantsHeaders from "../headers/SearchDependants";
import getBeneficiariesHeaders from "../headers/SearchBeneficiaries";

export default {
  name: "search-members-form",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
  },
  props: [],
  mixins: [planSetter],
  data() {
    return {
      showTable: false,
      panel: [0, 1],
      searchForm: {
        firstName: null,
        lastName: null,
        pensionMembershipId: null,
        sin: null,
        dateOfBirth: null,
        beneficiaryType: null,
        beneficiarySpouseId: null,
      },
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "viewItem",
          icon: "visibility",
          title: "components.search_beneficiaries_form.details",
          handler: (item) => {
            let id = item.MemberIdentityId;
            if (item.BeneficiaryStatement) {
              id = item.BeneficiaryStatement.MemberIdentityId;
            }
            this.$router.push({
              name: "memberView",
              params: { id: id },
            });
          },
          visible: (item) => {
            return item;
          },
        },
      ],
      selectedItem: null,
      beneficiaryTypes: [],
      result: undefined,
      url: undefined,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "settings"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    ...mapGetters("plansMembers", { planIdentity: "planIdentity" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    setData(data) {
      console.log(data);
      this.result = data;
    },
    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },

    loadPlanData() {
      if (this.selectedPlan.PlanType === "Pension") {
        this.beneficiaryTypes = ["Spouse", "Primary", "Contingent"];
      } else {
        this.beneficiaryTypes = ["Dependant", "Beneficiary"];
      }
    },
    async submitSearchForm() {
      console.log("!!!", this.searchForm);
      let url;
      const filters = [];
      if (this.searchForm.beneficiaryType === "Spouse") {
        url = "plans/" + this.selectedPlan.Id + "/find-dependants";
      } else if (this.searchForm.beneficiaryType === "Primary") {
        url = "plans/" + this.selectedPlan.Id + "/find-beneficiaries";
        filters.push(`IsPrimary eq true`);
      } else if (this.searchForm.beneficiaryType === "Contingent") {
        url = "plans/" + this.selectedPlan.Id + "/find-beneficiaries";
        filters.push(`IsPrimary eq false`);
      } else if (this.searchForm.beneficiaryType === "Dependant") {
        url = "plans/" + this.selectedPlan.Id + "/find-dependants";
      } else if (this.searchForm.beneficiaryType === "Beneficiary") {
        url = "plans/" + this.selectedPlan.Id + "/find-beneficiaries";
      }
      console.log(url);
      this.url = url;
      if (this.searchForm.firstName) {
        if (url === "plans/" + this.selectedPlan.Id + "/find-beneficiaries") {
          filters.push(
            `(contains(tolower(FirstName), '${this.searchForm.firstName
              .toLowerCase()
              .replaceAll(
                "'",
                "''"
              )}') or contains(tolower(DependantIdentity/Current/FirstName), '${this.searchForm.firstName
              .toLowerCase()
              .replaceAll("'", "''")}'))`
          );
        } else {
          filters.push(
            `contains(tolower(Current/FirstName), '${this.searchForm.firstName
              .toLowerCase()
              .replaceAll("'", "''")}')`
          );
        }
      }
      if (this.searchForm.lastName) {
        if (url === "plans/" + this.selectedPlan.Id + "/find-beneficiaries") {
          filters.push(
            `(contains(tolower(LastName), '${this.searchForm.lastName
              .toLowerCase()
              .replaceAll(
                "'",
                "''"
              )}') or contains(tolower(DependantIdentity/Current/LastName), '${this.searchForm.lastName
              .toLowerCase()
              .replaceAll("'", "''")}'))`
          );
        } else {
          filters.push(
            `contains(tolower(Current/LastName), '${this.searchForm.lastName
              .toLowerCase()
              .replaceAll("'", "''")}')`
          );
        }
      }
      if (this.searchForm.pensionMembershipId) {
        if (url === "plans/" + this.selectedPlan.Id + "/find-dependants") {
          filters.push(
            `contains(tolower(SelfMemberIdentity/MemberIdentification/PensionMembershipId), '${this.searchForm.pensionMembershipId
              .toLowerCase()
              .replaceAll("'", "''")}')`
          );
        }
      }
      if (this.searchForm.sin) {
        if (url === "plans/" + this.selectedPlan.Id + "/find-beneficiaries") {
          filters.push(
            `contains(tolower(SIN), '${this.searchForm.firstName
              .toLowerCase()
              .replaceAll("'", "''")}')`
          );
        } else {
          filters.push(
            `contains(tolower(Current/SIN), '${this.searchForm.firstName
              .toLowerCase()
              .replaceAll("'", "''")}')`
          );
        }
      }
      if (this.searchForm.dateOfBirth) {
        const dob = this.searchForm.dateOfBirth;
        if (url === "plans/" + this.selectedPlan.Id + "/find-beneficiaries") {
          filters.push(
            `(date(DateOfBirth) eq ${dob} or date(DependantIdentity/Current/DateOfBirth) eq ${dob})`
          );
        } else {
          filters.push(`date(Current/DateOfBirth) eq ${dob}`);
        }
      }

      if (this.searchForm.beneficiarySpouseId) {
        if (url === "plans/" + this.selectedPlan.Id + "/find-beneficiaries") {
          filters.push(
            `PensionBeneficiaryId eq ${this.searchForm.beneficiarySpouseId}`
          );
        } else {
          filters.push(
            `PensionSpouseId eq ${this.searchForm.beneficiarySpouseId}`
          );
        }
      }

      let headers = [];
      if (url === "plans/" + this.selectedPlan.Id + "/find-beneficiaries") {
        headers = getBeneficiariesHeaders(this.selectedPlan.PlanType);
      } else {
        headers = getDependantsHeaders(this.selectedPlan.PlanType);
      }
console.log(headers, filters, this.result);
      if (filters.length > 0) {
        const f = filters.join(" and ");
        this.provider = new PbasOData(this.$axiosHttp, url, headers);
        this.provider.filter = f;
        this.showTable = true;
        if (this.result !== undefined) {
          this.$nextTick(() => {
            this.$refs.table.getDataAsync();
          });
        }
      } else {
        this.showTable = false;
      }
    },
  },
};
</script>
